import { render, staticRenderFns } from "./ViewAttribute.vue?vue&type=template&id=5822eace&scoped=true&"
import script from "./ViewAttribute.vue?vue&type=script&lang=js&"
export * from "./ViewAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ViewAttribute.vue?vue&type=style&index=0&id=5822eace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822eace",
  null
  
)

export default component.exports